export default {
    bookings: state => state.bookings,
    activeBooking: state => state.activeBooking,
    manageBookingDialog: state => state.manageBookingDialog,
    manageDeleteBookingDialog: state => state.manageDeleteBookingDialog,
    previewJobDialog: state => state.previewJobDialog,
    dailyValue: state => state.dailyValue,
    entries: state => state.entries,
    cumulative: state => state.cumulative
}
